<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :width="'50%'"
        height="auto"
        :TitleWindow="title"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            {
                text: $t('Shared.Save'),
                variant: 'primary',
                action: emitEventOK
            }
        ]"
        @Close="close"
    >
        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('PostPayment.PayCode')"
                    v-bind:ModelCode="editableItem.payCode"
                    v-bind:ModelDescription="editableItem.payCode"
                    v-bind:RefCode="'PayCode'"
                    v-bind:Api="'PostPayment/reasonPaymentLookup'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'code'"
                    :SearchTitle="$t('PostPayment.PayCode')"
                    :GetValues="getPayCode"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :ServerSidePagination="true"
                    v-bind:Fields="payCodeFields"
                    :isRequired="true"
                    :isValid="isValid('payCode')"
                    :IsDisabled="editMode"
                />
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit
                    v-bind:Label="$t('PostPayment.Manual.Adj')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'adj-amt'"
                    v-model.number="editableItem.adjAmt"
                    v-bind:Id="'adj-amt'"
                    :isValid="isValid('adjAmt')"
                    :isRequired="true"
                />
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit
                    v-bind:Label="$t('PostPayment.ReasonNo')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'reason-number'"
                    v-bind:MaxLengthProp="4"
                    v-model="editableItem.reasonNo"
                    v-bind:Id="'reason-number'"
                />
            </b-col>
        </b-row>
    </BaseModal>
</template>

<script>
import Utils from '@/common/utils.js';
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'InsuranceMultiAdjPaymentPostingModal',
    mixins: [validationMixin, ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        value: {
            type: Object,
            default: null
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modalId: `modal-${Utils.generateUUID()}`,
            emitCloseEvent: false,
            editableItem: this.value
                ? { ...this.value }
                : { payCode: null, adjAmt: 0, reasonNo: null },
            payCodeFields: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.Code'),
                    class: 'text-left'
                },
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-left'
                }
            ]
        };
    },
    computed: {
        title() {
            return this.editMode
                ? `${this.$t('Shared.Edit')} ${this.$t('PostPayment.Manual.MultiAdjTitle')}`
                : `${this.$t('Shared.Add')} ${this.$t('PostPayment.Manual.MultiAdjTitle')}`;
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        },
        value(newVal) {
            this.editableItem = newVal
                ? { ...newVal }
                : { payCode: null, adjAmt: 0, reasonNo: null };
        }
    },
    methods: {
        resetData() {
            this.editableItem = this.value
                ? { ...this.value }
                : { payCode: null, adjAmt: 0, reasonNo: null };
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();
            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate()) {
                this.$emit('update:visible', false);
                this.$emit('ok', this.editableItem);
                this.resetData();
            } else {
                bvModalEvent.preventDefault();
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.resetData();
                this.emitCloseEvent = false;
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate() {
            const rules = {
                payCode: [validationRules.required(this.$t('Msg.CheckRequiredFields'))],
                adjAmt: [validationRules.required(this.$t('Msg.CheckRequiredFields'))]
            };

            return this.validateFields(rules, this.editableItem);
        },

        getPayCode(value) {
            this.editableItem.payCode = value ? value.code : null;
        }
    }
};
</script>
